"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=version-config.js.map